import React, { useState } from 'react';
import { Button } from '@material-ui/core';
import ReactPlayer from 'react-player';
import PlayButton from './PlayButton';

interface VideoPlayerProps {
  url: string,
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void,
  isSmall?: boolean
}

const VideoPlayer: React.FC<VideoPlayerProps> = ({ url, onClick, isSmall = false }) => {
  const [isPlaying, setIsPlaying] = useState(false);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    if (onClick) {
      onClick(event);
      event.stopPropagation();
    } else {
      setIsPlaying(!isPlaying);
    }
  };

  return (
    <div style={{ width: '100%', height: '100%', backgroundColor: '#000', position: 'relative' }}>
      { onClick
        ? <Button style={{ position: 'absolute', opacity: '0.0', width: '100%', height: '100%', zIndex: 1 }} onClick={handleClick} />
        : null }

      <ReactPlayer
        width='100%'
        height='100%'
        light
        playing={onClick ? false : isPlaying}
        controls
        playIcon={<PlayButton onClick={handleClick} size={isSmall ? 33 : 73} />}
        url={url}
        config={{
          youtube: {
            embedOptions: {
              height: '100%',
              width: '100%'
            },
            playerVars: {
              modestbranding: 1
            }
          },
          vimeo: {
            playerOptions: {
              height: '100%x',
              width: '100%',
              maxwidth: '100%'
            }
          }
        }}
      />
    </div>
  );
};

export default VideoPlayer;
